import { ISeasonsInitialState } from '@types';
import { createSelector } from 'reselect';
import { RootState } from 'store';

const seasonsSelector = (state: RootState) => state.seasons;

const seasonsListSelector = createSelector([seasonsSelector], (seasons: ISeasonsInitialState) => seasons.seasonsList);

const seasonSelector = createSelector([seasonsSelector], (seasons: ISeasonsInitialState) => seasons.season);

export const seasonsSel = {
    seasonsSelector,
    seasonSelector,
    seasonsListSelector,
};
